let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("53Cb8")).then(() => parcelRequire('lQYGl'));